import React from 'react';
import Link from 'next/link';

interface Button {
  id?: string;
  label: string;
  url?: string;
  external_link?: boolean;
}

interface HeroButtonsProps {
  buttons: Button[];
}

export const HeroButtons: React.FC<HeroButtonsProps> = ({ buttons }) => {
  if (!buttons || buttons.length === 0) return null;

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto mx-auto lg:mx-0 justify-center lg:justify-start z-1">
      {buttons.map((btn, btnIndex) => {
        const buttonContent = (
          <div
            className={`px-8 py-2 rounded-3xl inline-flex justify-center items-center overflow-hidden transition-colors duration-300 ${btnIndex === 0
                ? 'bg-[#F05A49] hover:bg-opacity-90'
                : 'outline-1 outline-offset-[-1px] outline-grey-ligth hover:bg-grey-ligth hover:bg-opacity-10'
              }`}
          >
            <div
              className={`text-center text-sm font-medium font-['Poppins'] uppercase ${btnIndex === 0 ? 'text-white' : 'text-grey-dark'
                }`}
            >
              {btn.label}
            </div>
          </div>
        );

        // Se for link externo, usa tag <a>
        if (btn.external_link) {
          return (
            <a
              key={`btn-${btn.id || btnIndex}`}
              href={btn.url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              {buttonContent}
            </a>
          );
        }

        // Se for link interno, usa Next.js Link
        return (
          <Link
            key={`btn-${btn.id || btnIndex}`}
            href={btn.url || '#'}
            className="w-full sm:w-auto"
          >
            {buttonContent}
          </Link>
        );
      })}
    </div>
  );
};
